import React, { useEffect, useState } from 'react';
import Alert from "../../../utils/Alert.js";
import { qcRequest, serviceAcceptanceRequest } from '../../../services/servicesServices';

const QualityControl = ({ rowData }) => {
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        setIsChecked(rowData.qc_checked)
    }, [])

    const handleCheckBoxChange = async (event) => {
        const checked = event.target.checked;
        setIsChecked(checked);
        try {
            const response = await qcRequest(rowData.code, checked);
            if (response.status === 200) {
                window.location.reload();
            }
        } catch (error) {
            Alert("خطا", "در ارسال درخواست مشکلی به وجود آمده", "error");
        }
    }
    return (
        <span>      
            <form>
                <input 
                    type='checkbox' 
                    id='qualityControl' 
                    name='qualityControl' 
                    checked={isChecked} 
                    disabled={!rowData.qc_is_enable}
                    onChange={handleCheckBoxChange} 
                />
            </form>
        </span>  
    );
}

export default QualityControl;
